export default __webpack_public_path__ + "bf237d75383f33806ee988cae73cfe1c.svg";